import React from "react";
import { StoriesThumb } from "./StoriesThumb/StoriesThumb";
import { StoriesModal } from "../Stories/StoriesModal";
import { useStoriesProviderData } from "../../providers/storiesProvider";
import { useGetStoriesQuery } from "../../providers/storiesProvider";

import classNames from "classnames/bind";
import styles from "./StoriesBar.module.scss";
import StoriesBarSkeleton from "./StoriesBarSkeleton";

const cx = classNames.bind(styles);

const StoriesBar = () => {
  const { data: stories, isLoading, isFetching } = useGetStoriesQuery();
  const { setIsModalOpened, setStoriesData } = useStoriesProviderData();

  const isLoadingOrFetching = isLoading || isFetching;

  return (
    <>
      <StoriesModal />
      <div className={cx("wrapper")}>
        {isLoadingOrFetching ? (
          <StoriesBarSkeleton />
        ) : (
          stories?.map((story, key) => {
            return (
              <div
                key={story.id}
                onClick={() => {
                  setStoriesData(stories);
                  setIsModalOpened();
                }}
                className={cx("thumb")}
              >
                <StoriesThumb index={key} thumbName={story.name} thumbnailURL={story.thumbnailURL} />
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export { StoriesBar };
